export default __webpack_public_path__ + "static/media/sandal4.cbff7329.jpeg";